import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: palette.primary.screen
      }
    }
  }
};
